// src/data/rankings.js
export const rankingsData = [
  {
    id: 1,
    org: "QS World Bro Rankings",
    rank: "#1",
    category: "Global Brotherhood & Loyalty",
    description:
      'It has topped the list for five consecutive years, achieving full marks in the "bringing food to friends" and "available whenever needed" categories.',
    icon: "🏆",
  },
  {
    id: 2,
    org: "THE (Times Higher Entertainment)",
    rank: "Top 3",
    category: "Most Fun Campus",
    description:
      "Because the university uses the State Grid for cryptocurrency mining.",
    icon: "🎮",
  },
  {
    id: 3,
    org: "Shanghai 'Soft' Science",
    rank: "S++",
    category: "Advanced Procrastination Research",
    description:
      'Our university holds an absolute dominant position in the research field of "how to drag the deadline to the last second".',
    icon: "💤",
  },
  {
    id: 4,
    org: "Bushigemen Internal Audit",
    rank: "∞",
    category: "Vibes & Chill Level",
    description: "Officially certified: The atmosphere here is boundless.",
    icon: "✨",
  },
];